import { kuiperClassNames } from '@opallabs/kuiper'
import { WorkflowIcon } from '@opallabs/lapidary'
import { Content } from '@opallabs/wormhole/types'
import { getApprovalContent } from './helpers/approvalStatus'
import { getDeliveryContent } from './helpers/deliveryStatus'
import { Phase, User } from './types'
import './styles.scss'

type WorkflowPopoverFooterProps = {
  content: Content
  finalApprovalReached: boolean
  phases: Array<Phase>
  users: Array<User>
  workflowStarted: boolean
}

const WorkflowPopoverFooter = ({
  content,
  finalApprovalReached,
  phases,
  users,
  workflowStarted,
}: WorkflowPopoverFooterProps) => {
  const { status: approvalStatus, description: approvalDescription } =
    getApprovalContent({
      content,
      phases,
      workflowStarted,
      finalApprovalReached,
    })

  const { status: deliveryStatus, description: deliveryDescription } =
    getDeliveryContent(content, users)

  return (
    <section className={kuiperClassNames('workflowPopoverFooter')}>
      <div
        className={kuiperClassNames(
          'workflowPopoverFooter__status',
          'workflowPopoverFooter__approvalStatus'
        )}
      >
        {approvalStatus && <WorkflowIcon status={approvalStatus} size={24} />}
        <div
          className={kuiperClassNames('workflowPopoverFooter__copy')}
          style={!approvalStatus ? { paddingLeft: '24px' } : {}}
        >
          {approvalDescription}
        </div>
      </div>

      <div className={kuiperClassNames('workflowPopoverFooter__status')}>
        {deliveryStatus && <WorkflowIcon status={deliveryStatus} size={24} />}
        <div className={kuiperClassNames('workflowPopoverFooter__copy')}>
          {deliveryDescription}
        </div>
      </div>
    </section>
  )
}

export default WorkflowPopoverFooter
